import type { BuildType } from 'src/enums/build/build-type';
import type { Language } from 'src/enums/language';
import type { PAGE_LEVEL } from 'src/enums/page-level';

export type PageLanguage = {
  language: Language;
  path: string;
};

export type AlternatePage = PageLanguage & {
  buildType: BuildType;
};

export enum PageLayoutType {
  blank = 'blank',
  simple = 'simple',
  global = 'global',
  club = 'club',
  careers = 'careers',
}

type PageBlankLayoutOptions = {
  type: PageLayoutType.blank;
};

type PageSimpleLayoutOptions = {
  type: PageLayoutType.simple;
  shouldShowFooter?: boolean; // default false
};

type PageGlobalLayoutOptions = {
  type: PageLayoutType.global;
  pageLevel?: PAGE_LEVEL;
};

type PageClubLayoutOptions = {
  type: PageLayoutType.club;
  pageLevel?: PAGE_LEVEL;
};

type PageCareersLayoutOptions = {
  type: PageLayoutType.careers;
};

export type PageLayoutOptions =
  | PageBlankLayoutOptions
  | PageSimpleLayoutOptions
  | PageGlobalLayoutOptions
  | PageClubLayoutOptions
  | PageCareersLayoutOptions;

export type PageGlobalOrClubContext =
  | {
      isGlobalPage: true;
      clubId?: string | undefined | null;
      clubDirectoryName?: string | undefined | null;
    }
  | {
      isGlobalPage: false;
      clubId: string;
      clubDirectoryName: string;
    };

type PageContextBase = {
  globalDirectoryName: string;
  language: Language;
  pageLanguages?: PageLanguage[];
  alternatePages?: AlternatePage[];
  basePath: string;
  buildType: BuildType;
  untranslatedPath?: string;
  seo: {
    allowPageIndex: boolean;
    title?: string;
    description?: string;
  };
  pageLayout: PageLayoutOptions;
  inlineImageData?: Record<string, string>;
  notFoundDirectoryNames?: string[]; // Only for the `/404/` page
};

export type PageContext = PageGlobalOrClubContext & PageContextBase;

export type ClubPageContext = Extract<PageGlobalOrClubContext, { isGlobalPage: false }> &
  PageContextBase;
